<script setup lang="ts">
defineProps<{
  active: string;
  items: Array<{ id: string; label: string; href?: string }>;
}>();
defineEmits<{ select: [id: string] }>();
const paths: Record<string, string> = {
  home: 'M3 10 12 3l9 7M5 9v12h5v-7h4v7h5V9',
  orders: 'M8 4H5v17h14V4h-3M8 3h8v4H8zM8 12h8M8 16h5',
  stats: 'M4 20V11M12 20V4M20 20V8',
  catalog: 'M4 7h16v14H4zM8 7V5a4 4 0 0 1 8 0v2',
  boxes: 'm3 7 9-4 9 4v10l-9 4-9-4zM3 7l9 4 9-4M12 11v10',
  more: 'M12 5v14M5 12h14',
};
</script>

<template>
  <nav
    class="ops-navigation"
    aria-label="Navigation principale"
    :style="{ '--ops-tabs': items.length }"
  >
    <component
      :is="item.href ? 'a' : 'button'"
      v-for="item in items"
      :key="item.id"
      :href="item.href"
      :type="item.href ? undefined : 'button'"
      :aria-current="active === item.id ? 'page' : undefined"
      :data-testid="`ops-nav-${item.id}`"
      :class="{ 'ops-nav-add': item.id === 'more' }"
      :aria-label="item.id === 'more' ? 'Créer et gérer' : undefined"
      @click="!item.href && $emit('select', item.id)"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path :d="paths[item.id] ?? paths.more" />
      </svg>
      <span :class="{ 'sr-only': item.id === 'more' }">{{ item.label }}</span>
    </component>
  </nav>
</template>
